import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { QuestionState } from '@proxy/questions';
import { AppBaseComponent } from 'src/app/shared/app-base.component';
import { EnumDescriptor } from 'src/app/shared/enum-descriptor';

@Component({
    selector: 'app-question-state-dropdown',
    templateUrl: './question-state-dropdown.component.html',
    standalone: false
})
export class QuestionStateDropdownComponent  extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() isDisabled = false;
  @Input() selectedQuestionState: QuestionState;

  @Output() changeQuestionState = new EventEmitter<QuestionState>();
  questionStates: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);

    if (this.isNullOrUndefined(this.selectedQuestionState)) {
      this.selectedQuestionState = QuestionState.Active;
    }
  }

  ngOnInit(): void {
    this.loadQuestionState();
    this.onSelected();
  }

  loadQuestionState(): void {
    this.questionStates = this.getEnumOptions(QuestionState, false);
  }

  onSelected(): void {
    this.changeQuestionState.emit(this.selectedQuestionState);
  }
}
